export const DEFAULT_PAGE_SIZE = 100;

export interface All<T> {
  data: T[];
  meta: {
    total: number;
  };
}

export interface AllInfinite<T> {
  data: T[];
  hasMoreAfter?: string;
  hasMoreBefore?: string;
}

export interface BaseGetAllParams {
  pageSize?: number;
  pageNumber?: number;
}
